import { sentimentTrackerOnboardingConstants } from "./sentimentTrackerOnboardingConstants";

const sentimentTrackerOnboardingActions = {};

sentimentTrackerOnboardingActions.updateSentimentTrackerOnboardingData = (payload = {}) => ({
    type: sentimentTrackerOnboardingConstants.SENTIMENT_UPDATE_ONBOARDING_DATA,
    payload,
});


sentimentTrackerOnboardingActions.getOnboardingData = () => ({
    type: sentimentTrackerOnboardingConstants.SENTIMENT_ONBOARDING_DATA_SAGA,
});

export { sentimentTrackerOnboardingActions };
